'use client'

import {
  __closeSelectPickupPointOfSaleDrawerAtom,
  __isSelectPickupPointOfSaleDrawerOpenAtom,
  __selectPickupPointOfSaleDrawerAtom,
} from '@/feature/point-of-sale/services/pointOfSale.store'
import { gql } from '@gql-generated/gql'
import { useAtomValue, useSetAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { switchPickupPointOfSale } from '../../../services/pointOfSale.action'
import { SelectablePointOfSaleCard } from '../../selectable-point-of-sale-card/SelectablePointOfSaleCard.client'
import SelectPointOfSaleDrawer_V2 from '../_components/SelectPointsOfSaleDrawer.client'
import { useLazyQuery } from '@apollo/client'
import { SelectPickupPointOfSaleDrawerDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query SelectPickupPointOfSaleDrawer($searchPostalCode: String) {
    currentUser {
      availablePointsOfSalePickup(searchPostalCode: $searchPostalCode) {
        ...SelectablePointOfSaleCard_V2_pointOfSale
      }
    }
  }
`)

export function SelectPickupPointOfSaleDrawer() {
  const { selectedId, isOpen, onClose } = useAtomValue(__selectPickupPointOfSaleDrawerAtom)

  const closeDrawer = useSetAtom(__closeSelectPickupPointOfSaleDrawerAtom)

  const [searchPostalCode, setSearchPostalCode] = useState<string>('')

  const [loadPointsOfSale, { data, loading, error }] = useLazyQuery(
    SelectPickupPointOfSaleDrawerDocument,
    {
      nextFetchPolicy: 'cache-only',
    },
  )

  /**
   * Load the points of sale when opening the drawer
   */
  useEffect(() => {
    if (!isOpen) return
    loadPointsOfSale({ variables: { searchPostalCode } })
  }, [isOpen, loadPointsOfSale, searchPostalCode])

  return (
    <SelectPointOfSaleDrawer_V2
      isOpenAtom={__isSelectPickupPointOfSaleDrawerOpenAtom}
      pointsOfSale={data?.currentUser?.availablePointsOfSalePickup}
      isLoading={loading}
      error={error}
      searchPostalCode={searchPostalCode}
      onSearchPostalCodeChangeAction={setSearchPostalCode}
      renderPointOfSale={(pos) => (
        <SelectablePointOfSaleCard
          pointOfSale={pos}
          isSelected={selectedId === pos.id}
          displayStock={false}
          onPointOfSaleSelected={async (pos) => {
            await switchPickupPointOfSale(pos.id, { setAsFavoriteToo: false })
            onClose?.(pos.id)
            closeDrawer()
          }}
        />
      )}
    />
  )
}
